import { Box } from "@mui/material";
import React, { useState } from "react";
import ConfirmDialog from "../../components/modal/ConfirmDialog";
import CustomTable from "../../components/table/CustomTable";
import { useStyles } from "./styles";
import RowDetails from "./rowDetails";

const LogsTable = ({ data }) => {
  const classes = useStyles();
  const [selectedRow, setRow] = useState(null);

  const columns = [
    {
      label: "Tasks",
      field: "name",
    },
    {
      label: "Status",
      field: "status",
      render: (row) => (
        <Box
          className={` ${classes.chip} ${classes[row?.status?.toLowerCase()]}`}
        ></Box>
      ),
    },
  ];
  return (
    <Box>
      <CustomTable
        columns={columns}
        data={data}
        detailPanel={(row) => {
          return <RowDetails data={row} />;
        }}
      />
      <ConfirmDialog
        open={Boolean(selectedRow?.name)}
        title={selectedRow?.name}
        content={selectedRow?.logs}
        type="info"
        onClose={() => setRow(null)}
      />
    </Box>
  );
};

export default LogsTable;
